



































































import {Component, Prop} from "vue-property-decorator";
import {HttpResponse} from "@/types/http";
import VueError from '@/components/VueError.vue';
import Loading from '@/components/Loading.vue';
import CustomSectionHeader from '@/components/CustomSectionHeader.vue';
import {Device} from "@/types/core";

import { curCoreClient, CoreClient } from '@/services/CoreClient';
import MetaSection from "@/components/device/meta/MetaSection.vue";
import MetaItem from "@/components/device/meta/MetaItem.vue";

@Component({
  components:{
    VueError,
    Loading,
    CustomSectionHeader,
    MetaItem,
    MetaSection
  }
})
export default class DeviceMetaSection extends MetaSection {
  @Prop({ default: () => {},  type: Object}) device!:Device;

  private coreClient:CoreClient = curCoreClient;

  protected getMeta(): Record<string, string | number | boolean | string[] | number[]> {
    return this.device.customMeta;
  }

  protected async saveMeta(newMeta: Record<string, string | number | boolean | string[] | number[]>): Promise<HttpResponse> {
    const reply = await this.coreClient.updateDeviceMetadata({
      deviceId: this.device.deviceId,
      customMeta: newMeta
    });

    if(!reply.errorMsg) {
      // we update the local copy
      this.device.customMeta = newMeta;
    }

    return reply;
  }
}
